/**
 * @generated SignedSource<<c1d232db329e08d8e048e1ef47432669>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PROJECT_STATUS = "OPPORTUNITY" | "PLANNING" | "RUNNING" | "HALTED" | "DONE" | "%future added value";
export type AddMemberToProgramInput = {
  programId: string;
  personIds?: ReadonlyArray<string | null> | null;
  role?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type addMemberToProgramMutation$variables = {
  input: AddMemberToProgramInput;
};
export type addMemberToProgramMutation$data = {
  readonly addMemberToProgram: {
    readonly program: {
      readonly node: {
        readonly id: string;
        readonly name: string | null;
        readonly description: string | null;
        readonly prefix: string | null;
        readonly color: string | null;
        readonly startDate: string | null;
        readonly endDate: string | null;
        readonly members: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly role: string | null;
              readonly person: {
                readonly id: string;
                readonly profilePictureId: string | null;
                readonly fullName: string | null;
                readonly email: string | null;
                readonly initials: string | null;
              } | null;
            } | null;
          } | null> | null;
        } | null;
        readonly projects: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly serviceCompanyId: number | null;
              readonly companyProjectId: number | null;
              readonly name: string | null;
              readonly prefix: string | null;
              readonly color: string | null;
              readonly startDate: string | null;
              readonly endDate: string | null;
              readonly stage: PROJECT_STATUS | null;
              readonly clients: {
                readonly edges: ReadonlyArray<{
                  readonly node: {
                    readonly id: string;
                    readonly name: string;
                    readonly logoId: string | null;
                  } | null;
                } | null> | null;
              } | null;
              readonly status: {
                readonly edges: ReadonlyArray<{
                  readonly node: {
                    readonly id: string;
                    readonly description: string | null;
                    readonly color: string | null;
                    readonly addedAt: string | null;
                  } | null;
                } | null> | null;
              } | null;
              readonly currentProjectStatus: {
                readonly id: string;
                readonly color: string | null;
                readonly description: string | null;
                readonly person: {
                  readonly id: string;
                  readonly firstName: string | null;
                  readonly lastName: string | null;
                  readonly profilePictureId: string | null;
                } | null;
              } | null;
              readonly financialNumbers: {
                readonly allActualTimeAndExpenses: number | null;
                readonly recognitionProfitPercentage: number | null;
                readonly allTotalTimeAndExpensesAtCompletion: number | null;
              } | null;
              readonly financialNumbersToDate: {
                readonly recognitionProfitPercentage: number | null;
              } | null;
              readonly totalRevenueRecognition: number | null;
              readonly totalRevenueRecognitionToDate: number | null;
              readonly totalTimeRevenueRecognitionToDate: number | null;
              readonly totalBillableExpensesAtCompletion: number | null;
              readonly settings: {
                readonly edges: ReadonlyArray<{
                  readonly node: {
                    readonly id: string;
                    readonly name: string | null;
                    readonly value: string | null;
                  } | null;
                } | null> | null;
              } | null;
              readonly userRelationTypes: ReadonlyArray<string | null> | null;
            } | null;
          } | null> | null;
        } | null;
      } | null;
    } | null;
  } | null;
};
export type addMemberToProgramMutation = {
  variables: addMemberToProgramMutation$variables;
  response: addMemberToProgramMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prefix",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ProjectServiceProgramMemberTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectServiceProgramMemberType",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "role",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Person",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fullName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "initials",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      },
      (v11/*: any*/)
    ],
    "storageKey": null
  },
  (v12/*: any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recognitionProfitPercentage",
  "storageKey": null
},
v15 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ProjectServiceProjectTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectServiceProjectType",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "serviceCompanyId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyProjectId",
            "storageKey": null
          },
          (v3/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ClientTypeConnection",
            "kind": "LinkedField",
            "name": "clients",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ClientTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Client",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "logoId",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectServiceProjectStatusTypeConnection",
            "kind": "LinkedField",
            "name": "status",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectServiceProjectStatusTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectServiceProjectStatusType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "addedAt",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectStatus",
            "kind": "LinkedField",
            "name": "currentProjectStatus",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v6/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Person",
                "kind": "LinkedField",
                "name": "person",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FinancialNumbers",
            "kind": "LinkedField",
            "name": "financialNumbers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "allActualTimeAndExpenses",
                "storageKey": null
              },
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "allTotalTimeAndExpensesAtCompletion",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FinancialNumbers",
            "kind": "LinkedField",
            "name": "financialNumbersToDate",
            "plural": false,
            "selections": [
              (v14/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalRevenueRecognition",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalRevenueRecognitionToDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalTimeRevenueRecognitionToDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalBillableExpensesAtCompletion",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectServiceProjectSettingTypeConnection",
            "kind": "LinkedField",
            "name": "settings",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectServiceProjectSettingTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectServiceProjectSettingType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "value",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userRelationTypes",
            "storageKey": null
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      },
      (v11/*: any*/)
    ],
    "storageKey": null
  },
  (v12/*: any*/)
],
v16 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "addMemberToProgramMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AddMemberToProgramPayload",
        "kind": "LinkedField",
        "name": "addMemberToProgram",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectServiceProgramTypeEdge",
            "kind": "LinkedField",
            "name": "program",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProgramType",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": "members",
                    "args": null,
                    "concreteType": "ProjectServiceProgramMemberTypeConnection",
                    "kind": "LinkedField",
                    "name": "__Program_members_connection",
                    "plural": false,
                    "selections": (v13/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": "projects",
                    "args": null,
                    "concreteType": "ProjectServiceProjectTypeConnection",
                    "kind": "LinkedField",
                    "name": "__Program_projects_connection",
                    "plural": false,
                    "selections": (v15/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "addMemberToProgramMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AddMemberToProgramPayload",
        "kind": "LinkedField",
        "name": "addMemberToProgram",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectServiceProgramTypeEdge",
            "kind": "LinkedField",
            "name": "program",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProgramType",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": (v16/*: any*/),
                    "concreteType": "ProjectServiceProgramMemberTypeConnection",
                    "kind": "LinkedField",
                    "name": "members",
                    "plural": false,
                    "selections": (v13/*: any*/),
                    "storageKey": "members(first:10000)"
                  },
                  {
                    "alias": null,
                    "args": (v16/*: any*/),
                    "filters": [],
                    "handle": "connection",
                    "key": "Program_members",
                    "kind": "LinkedHandle",
                    "name": "members"
                  },
                  {
                    "alias": null,
                    "args": (v16/*: any*/),
                    "concreteType": "ProjectServiceProjectTypeConnection",
                    "kind": "LinkedField",
                    "name": "projects",
                    "plural": false,
                    "selections": (v15/*: any*/),
                    "storageKey": "projects(first:10000)"
                  },
                  {
                    "alias": null,
                    "args": (v16/*: any*/),
                    "filters": [],
                    "handle": "connection",
                    "key": "Program_projects",
                    "kind": "LinkedHandle",
                    "name": "projects"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b182f1973e2da8ffece46c75d4bde9ee",
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "addMemberToProgram",
            "program",
            "node",
            "members"
          ]
        },
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "addMemberToProgram",
            "program",
            "node",
            "projects"
          ]
        }
      ]
    },
    "name": "addMemberToProgramMutation",
    "operationKind": "mutation",
    "text": "mutation addMemberToProgramMutation(\n  $input: AddMemberToProgramInput!\n) {\n  addMemberToProgram(input: $input) {\n    program {\n      node {\n        id\n        name\n        description\n        prefix\n        color\n        startDate\n        endDate\n        members(first: 10000) {\n          edges {\n            node {\n              id\n              role\n              person {\n                id\n                profilePictureId\n                fullName\n                email\n                initials\n              }\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        projects(first: 10000) {\n          edges {\n            node {\n              id\n              serviceCompanyId\n              companyProjectId\n              name\n              prefix\n              color\n              startDate\n              endDate\n              stage\n              clients {\n                edges {\n                  node {\n                    id\n                    name\n                    logoId\n                  }\n                }\n              }\n              status {\n                edges {\n                  node {\n                    id\n                    description\n                    color\n                    addedAt\n                  }\n                }\n              }\n              currentProjectStatus {\n                id\n                color\n                description\n                person {\n                  id\n                  firstName\n                  lastName\n                  profilePictureId\n                }\n              }\n              financialNumbers {\n                allActualTimeAndExpenses\n                recognitionProfitPercentage\n                allTotalTimeAndExpensesAtCompletion\n              }\n              financialNumbersToDate {\n                recognitionProfitPercentage\n              }\n              totalRevenueRecognition\n              totalRevenueRecognitionToDate\n              totalTimeRevenueRecognitionToDate\n              totalBillableExpensesAtCompletion\n              settings {\n                edges {\n                  node {\n                    id\n                    name\n                    value\n                  }\n                }\n              }\n              userRelationTypes\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d260de110925d808189931df384e95d6";

export default node;
